import { baseApi } from "@/Redux/api/baseApi";

const podcastApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPodcast: builder.query({
      query: (limit) => ({
        url: `public/podcast/view?limit=${limit}`,
        method: "GET",
      }),
    }),

    getSinglePodcast: builder.query({
      query: (id) => ({
        url: `public/podcast/view/${id}`,
        method: "GET",
      }),
    }),

    getPodcastComment: builder.query({
      query: (id) => ({
        url: `public/podcast/comment/${id}`,
        method: "GET",
      }),
    }),

    followPodcast: builder.mutation({
      query: (data) => ({
        url: `public/interaction/interact/follow`,
        method: "POST",
        body: data,
      }),
    }),

    commentPodcast: builder.mutation({
      query: (data) => ({
        url: `public/podcast/comment`,
        method: "POST",
        body: data,
      }),
    }),

    updatePodcastComment: builder.mutation({
      query: (data) => ({
        url: `public/podcast/comment/${data?.id}`,
        method: "PATCH",
        body: data,
      }),
    }),

    deletePodcastComment: builder.mutation({
      query: (id) => ({
        url: `public/podcast/comment/${id}`,
        method: "DELETE",
      }),
    }),

    likePodcast: builder.mutation({
      query: (data) => ({
        url: `public/interaction/interact/likes`,
        method: "POST",
        body: data,
      }),
    }),

    viewPodcast: builder.mutation({
      query: (data) => ({
        url: `public/interaction/interact/views`,
        method: "POST",
        body: data,
      }),
    }),

    listenPodcast: builder.mutation({
      query: (data) => ({
        url: `public/interaction/interact/listens`,
        method: "POST",
        body: data,
      }),
    }),

    recommendationPodcast: builder.query({
      query: () => ({
        url: `/public/interaction/recommendations`,
        method: "GET",
      }),
    }),

    searchItems: builder.query({
      query: (search) => ({
        url: `public/search/query?q=${search}`,
        method: "GET",
      }),
    }),

    getMyListenPodcast: builder.query({
      query: () => ({
        url: `public/interaction/listen/podcast`,
        method: "GET",
      }),
    }),

    mostViewPodcast: builder.query({
      query: () => ({
        url: `/public/interaction/mostViewedPodcast`,
        method: "GET",
      }),
    }),

    mostLikePodcast: builder.query({
      query: () => ({
        url: `/public/interaction/mostLikedPodcast`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllPodcastQuery,
  useGetSinglePodcastQuery,
  useFollowPodcastMutation,
  useCommentPodcastMutation,
  useLikePodcastMutation,
  useGetPodcastCommentQuery,
  useUpdatePodcastCommentMutation,
  useDeletePodcastCommentMutation,
  useViewPodcastMutation,
  useListenPodcastMutation,
  useRecommendationPodcastQuery,
  useSearchItemsQuery,
  useGetMyListenPodcastQuery,
  useMostViewPodcastQuery,
  useMostLikePodcastQuery
} = podcastApi;
